import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import toast from "react-hot-toast";
import { useForm } from "react-hook-form";
import Icon from "@mdi/react";
import { mdiChevronDown, mdiChevronRight } from "@mdi/js";
import useDebounce from "../utilities/UseDebounce";
import UserAnnexesService from "../../../services/UserAnnexesService";
import ProfilDocNumber from "./ProfileDocNumber";
import UEModal from "./UEModal";
import ProfilAddress from "./ProfilAddress";
import ProfilAnnexesFormGroup from "./ProfileAnnexesFormGroup";
import Styles from "./ProfilAnnexes.scss";

const ProfilAnnexes = ({ entity, updateStructureInfo }) => {
   const [workingVar, setWorkingVar] = useState(null);
   const debouncedValue = useDebounce(workingVar, 2000);
   const [currentSection, setCurrentSection] = useState();
   const userAnnexesService = new UserAnnexesService();
   const [annexesDefault, setAnnexesDefault] = useState([]);
   const [showModal, setShowModal] = useState(false);
   const annexesList = [
      {
         id: 1,
         title: "Introduction et visa",
         annexes: [
            { option: { name: "delivrance_txt", title: "Délivrance" }, form: { form: "textarea", row: 1 } },
            { option: { name: "intro_txt", title: "Introduction" }, form: { form: "textarea", row: 10 } },
         ],
      },
      {
         id: 2,
         title: "Disposition applicable",
         annexes: [
            { option: { name: "a1_txt", title: "Mention de l'article 1" }, form: { form: "textarea", row: 15 } },
            { option: { name: "a2_txt", title: "Mention de l'article 2" }, form: { form: "textarea", row: 15 } },
         ],
      },
      {
         id: 3,
         title: "Taxes applicables",
         annexes: [
            {
               option: { name: "a5_ta", title: "TA - Part de la taxe d'aménagement" },
               form: { form: "number", step: 0.01 },
            },
            {
               option: { name: "a5_td", title: "TD - Part de la taxe départementale" },
               form: { form: "number", step: 0.01 },
            },
            {
               option: { name: "a5_rap", title: "RAP -  Part de la redevence archéologique" },
               form: { form: "number", step: 0.01 },
            },
         ],
      },
      {
         id: 4,
         title: "Participations exigibles",
         annexes: [
            {
               option: { name: "a6_txt1", title: "Participation exigible sans procédure de délibération préalable" },
               form: { form: "textarea", row: 4 },
            },
            {
               option: { name: "a6_txt2", title: "Participation prélablement instaurées par délibération" },
               form: { form: "textarea", row: 4 },
            },
         ],
      },
      {
         id: 5,
         title: "Référence signature",
         annexes: [{ option: { name: "sign_text", title: "Mention signature" }, form: { form: "textarea", row: 6 } }],
      },
   ];

   const {
      register,
      handleSubmit,
      formState: { errors },
      setValue,
   } = useForm({
      defaultValues: userAnnexesService.getdefaultAnnexes(),
   });

   useEffect(() => {
      $('[data-toggle="tooltip"]').tooltip();
      setAnnexesDefault(userAnnexesService.getdefaultAnnexes);
      let annexes = entity?.header_form_ref?.header_option;
      let parsedAnnexes = typeof annexes === "string" ? JSON.parse(annexes) : annexes;
      parsedAnnexes
         ? Object.entries(parsedAnnexes).map((item) => (item[1] && item[1] !== "" ? setValue(item[0], item[1]) : null))
         : null;
   }, []);

   useEffect(() => {
      if (debouncedValue) {
         setValue(debouncedValue?.name, debouncedValue?.value);
         submitAfterDebounce();
      }
   }, [debouncedValue]);

   useEffect(() => {}, [annexesDefault]);

   useEffect(() => {}, [showModal]);

   useEffect(() => {}, [entity]);

   const handleRestore = (e, ref) => {
      setValue(ref, annexesDefault[ref]);
      submitAfterDebounce();
   };

   const onHandleChange = (e) => {
      setWorkingVar({ name: e.target.name, value: e.target.value });
   };

   const submitAfterDebounce = async (e) => {
      let submitBtn = document.querySelector("#ue_entity_annexes_form_hidden_submit");
      await submitBtn.click();
   };

   const handleUpdateEntity = async (data) => {
      const args = { annexes: data };
      try {
         updateStructureInfo({
            ...entity,
            header_form_ref: {
               header_option: data,
            },
         });
         const result = await axios.put("/Api/user/entity", args);
         result?.data ? toast.success("Actualisation de vos données de structure réussie") : null;
      } catch (err) {
         console.log(err);
         toast.error("Un problème est survenu lors de l`'actualisation de vos données");
      }
   };

   const displayDocNumber = () => {
      setShowModal({
         title: "Numérotation",
         content: <ProfilDocNumber />,
      });
   };
   const displayPopup = (options, title = "Ma modal") => {
      let formGroup = options.map((item) => (
         <ProfilAnnexesFormGroup
            key={item.name}
            option={item.option}
            type={item.form}
            handleRestore={handleRestore}
            submitAfterDebounce={(e) => onHandleChange(e)}
            register={register}
         />
      ));

      console.log("item", formGroup);
      setShowModal({
         title: title,
         content: formGroup,
      });
   };

   return (
      <div className="d-flex flex-column w-100">
         <div className="accordion" id="accordionAnnexes">
            <div className={"ue-annexes-section"}>
               <div
                  className="ue-annexes_btn"
                  data-toggle="collapse"
                  data-target="#renseignement"
                  aria-expanded="false"
                  aria-controls="renseignement"
                  onClick={(e) => setCurrentSection(currentSection === "renseignement" ? null : "renseignement")}
               >
                  <div className={"d-flex flex-column justify-content-start align-items-start"}>
                     <div className={"ue-annexes-section-title font-weight-bold"} style={{ fontSize: "13px" }}>
                        Renseignement d'urbanisme
                     </div>
                  </div>
                  <div className={"ue-annexes-arrow"}>
                     <Icon path={currentSection !== "renseignement" ? mdiChevronRight : mdiChevronDown} size={0.7} />
                  </div>
               </div>
               <div className="collapse" id="renseignement" data-parent="#accordionAnnexes">
                  <form className={"w-100"} id="ue-entity-annexes-form" onSubmit={handleSubmit(handleUpdateEntity)}>
                     {showModal ? (
                        <UEModal title={showModal?.title} show={setShowModal} content={showModal?.content} />
                     ) : null}
                     <div
                        className={"d-flex justify-between w-100 rounded p-2"}
                        style={{ backgroundColor: "var(--theme-gray-bg-input)" }}
                     >
                        <div className={"flex-grow-1"}>Numérotation</div>
                        <div className={"btn btn-sm btn-secondary text-white"} onClick={() => displayDocNumber()}>
                           MODIFIER
                        </div>
                     </div>
                     {annexesList.length
                        ? annexesList.map((item) => {
                             return (
                                <div
                                   key={item.id}
                                   className={"d-flex justify-between w-100 rounded p-2 my-1"}
                                   style={{ backgroundColor: "var(--theme-gray-bg-input)" }}
                                >
                                   <div className={"flex-grow-1"}>{item.title}</div>
                                   <div
                                      className={"btn btn-sm btn-secondary text-white"}
                                      onClick={() => displayPopup(item.annexes, item.title)}
                                   >
                                      MODIFIER
                                   </div>
                                </div>
                             );
                          })
                        : null}
                     <button type={"submit"} id={"ue_entity_annexes_form_hidden_submit"} style={{ display: "none" }} />
                  </form>
                  <div className="card card-body border-0"></div>
               </div>
            </div>
            <div className={"ue-annexes-section"}>
               <div
                  className="ue-annexes_btn"
                  data-toggle="collapse"
                  data-target="#certif_toggle"
                  aria-expanded="false"
                  aria-controls="certif_toggle"
                  onClick={(e) => (currentSection === "certif_toggle" ? null : "certif_toggle")}
               >
                  <div className={"d-flex flex-column justify-content-start align-items-start"}>
                     <div className={"ue-annexes-section-title font-weight-bold"} style={{ fontSize: "13px" }}>
                        Certificat d’urbanisme
                     </div>
                  </div>
                  <div className={"ue-annexes-arrow"}>
                     <Icon path={currentSection !== "certif_toggle" ? mdiChevronRight : mdiChevronDown} size={0.7} />
                  </div>
               </div>
               <div className="collapse w-100 bg-white" id="certif_toggle" data-parent="#accordionAnnexes">
                  <form className={"w-100"} id="ue-entity-annexes-form" onSubmit={handleSubmit(handleUpdateEntity)}>
                     {showModal ? (
                        <UEModal title={showModal?.title} show={setShowModal} content={showModal?.content} />
                     ) : null}
                     <div
                        className={"d-flex justify-between w-100 rounded p-2"}
                        style={{ backgroundColor: "var(--theme-gray-bg-input)" }}
                     >
                        <div className={"flex-grow-1"}>Numérotation</div>
                        <div className={"btn btn-sm btn-secondary text-white"} onClick={() => displayDocNumber()}>
                           MODIFIER
                        </div>
                     </div>
                     {annexesList.length
                        ? annexesList.map((item) => {
                             return (
                                <div
                                   key={item.id}
                                   className={"d-flex justify-between w-100 rounded p-2 my-1"}
                                   style={{ backgroundColor: "var(--theme-gray-bg-input)" }}
                                >
                                   <div className={"flex-grow-1"}>{item.title}</div>
                                   <div
                                      className={"btn btn-sm btn-secondary text-white"}
                                      onClick={() => displayPopup(item.annexes, item.title)}
                                   >
                                      MODIFIER
                                   </div>
                                </div>
                             );
                          })
                        : null}
                     <button type={"submit"} id={"ue_entity_annexes_form_hidden_submit"} style={{ display: "none" }} />
                  </form>
               </div>
            </div>
            <div className={"ue-annexes-section"}>
               <div
                  className="ue-annexes_btn"
                  data-toggle="collapse"
                  data-target="#addresses"
                  aria-expanded="false"
                  aria-controls="addresses"
                  onClick={(e) => setCurrentSection(currentSection === "addresses" ? null : "addresses")}
               >
                  <div className={"d-flex flex-column justify-content-start align-items-start"}>
                     <div className={"ue-annexes-section-title font-weight-bold"} style={{ fontSize: "13px" }}>
                        Facturation
                     </div>
                  </div>
                  <div className={"ue-annexes-arrow"}>
                     <Icon path={currentSection !== "addresses" ? mdiChevronRight : mdiChevronDown} size={0.7} />
                  </div>
               </div>
               <div className="collapse" id="addresses" data-parent="#accordionAnnexes">
                  <ProfilAddress />
               </div>
            </div>
         </div>
      </div>
   );
};

const mapStateToProps = (state) => {
   return {
      userId: state.MeReducer.id,
      entity: state.MeReducer.entity,
      username: state.MeReducer.username,
      lastDocNumber: state.MeReducer.lastDocNumber,
      role: state.MeReducer.role,
      types: state.SubscribtionReducer.types,
      structureInfo: state.SubscribtionReducer.structureInfo,
   };
};

const mapDispatchTProps = (dispatch) => {
   return {
      updateStructureInfo: (e) => dispatch({ type: "UPDATE_STRUCTURE_INFO", data: e }),
      updateUserInfo: (e) => dispatch({ type: "UPDATE_USER_STATUS", data: e }),
      updateLastDocNumber: (e) => dispatch({ type: "UPDATE_LAST_DOC_NUMBER", data: e }),
   };
};

export default connect(mapStateToProps, mapDispatchTProps)(ProfilAnnexes);
